<template>
  <div class="contract-modal">
    <v-dialog
      v-model="isVisible"
      max-width="566"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="contract-modal__title headline"
          primary-title
        >
          EMPLOYMENT
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-form
            v-model="isFormValid"
            ref="contractForm"
          >
            <v-row>
              <v-col class="contract-modal__label-col" cols="12">
                Contract*
              </v-col>
              <v-col class="contract-modal__col" cols="12" md="6">
                <v-menu
                  ref="contractFromDate"
                  content-class="datepicker-menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <div class="form-field--date-wrapper" v-on="on">
                      <v-text-field
                        :value="contract.start_date | displayDate"
                        class="form-field"
                        dense
                        label="From"
                        placeholder="Chose date"
                        readonly
                        v-on="on"
                      >
                        <template #append>
                          <v-icon color="blue">
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="contract.start_date"
                    no-title
                    scrollable
                    :max="contract.end_date"
                    @input="$refs.contractFromDate.save(true)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="contract-modal__col" cols="12" md="6">
                <v-menu
                  ref="contractToDate"
                  content-class="datepicker-menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <div class="form-field--date-wrapper" v-on="on">
                      <v-text-field
                        :value="contract.end_date | displayDate"
                        class="form-field"
                        dense
                        label="To"
                        placeholder="Chose date"
                        readonly
                        v-on="on"
                      >
                        <template #append>
                          <v-icon color="blue">
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="contract.end_date"
                    no-title
                    scrollable
                    :min="contract.start_date"
                    @input="$refs.contractToDate.save(true)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="contract-modal__label-col" cols="12">
                Hourly rate for the customer*
              </v-col>
              <v-col class="contract-modal__col" cols="8" md="6">
                <v-text-field
                  v-model="contract.client_rate"
                  class="form-field"
                  :rules="[rules.required, rules.positive]"
                  dense
                  label="Rate*"
                  placeholder="Type hourly rate..."
                  suffix="/ h"
                  type="number"
                />
              </v-col>
              <v-col class="contract-modal__col" cols="4" md="6">
                <v-select
                  value="PLN"
                  class="form-field form-field--short"
                  :rules="[rules.required]"
                  :items="['PLN']"
                  dense
                  disabled
                  label="Currency*"
                  placeholder="Choose currency"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="contract-modal__label-col" cols="12">
                Hourly rate for the Developer*
              </v-col>
              <v-col class="contract-modal__col" cols="8" md="6">
                <v-text-field
                  v-model="contract.developer_rate"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Rate*"
                  placeholder="Type hourly rate..."
                  suffix="/ h"
                  type="number"
                />
              </v-col>
              <v-col class="contract-modal__col" cols="4" md="6">
                <v-select
                  value="PLN"
                  class="form-field form-field--short"
                  :rules="[rules.required]"
                  :items="['PLN']"
                  dense
                  disabled
                  label="Currency*"
                  placeholder="Choose currency"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="contract-modal__label-col" cols="12">
                Contract notice perdiod*
              </v-col>
              <v-col class="contract-modal__col" cols="12" md="6">
                <v-text-field
                  v-model="contract.notice_period"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Days*"
                  placeholder="Type number of days..."
                  suffix="days"
                  type="number"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="contract-modal__label-col" cols="12">
                Comment
              </v-col>
              <v-col class="contract-modal__col" cols="12">
                <v-textarea
                  v-model="contract.comment"
                  class="contract-modal__textarea"
                  dense
                  solo
                  flat
                  hide-details
                  height="106"
                  placeholder="Enter your comment"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="contract-modal__actions">
          <v-btn
            class="contract-modal__submit"
            color="blue"
            large
            :loading="processing"
            @click="submit"
          >
            {{ submitName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <ConfirmDialog ref="confirmDialog" /> -->
  </div>
</template>

<script>
import validationRules from '@/helpers/validators';
// import ConfirmDialog from '@/components/ConfirmDialog.vue';

const rules = validationRules;

export default {
  components: {
    // ConfirmDialog,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentContract: {
      type: Object,
      required: false,
    },
    candidate: {
      type: Object,
      required: false,
    },
    submitName: {
      type: String,
      required: false,
      default: 'Save Changes',
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      contract: {
        developer_id: '',
        client_rate: '',
        developer_rate: '',
        client_currency: 'PLN',
        developer_currency: 'PLN',
        start_date: '',
        end_date: '',
        notice_period: '',
        comment: '',
      },
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible(val) {
      if (this.currentContract) {
        this.contract = { ...this.currentContract };
      } else {
        this.contract = {
          developer_id: '',
          client_rate: '',
          developer_rate: '',
          client_currency: 'PLN',
          developer_currency: 'PLN',
          start_date: '',
          end_date: '',
          notice_period: '',
          comment: '',
        };
      }
      if (this.candidate) this.contract.candidate_id = this.candidate.id;

      if (!val) this.$refs.contractForm.resetValidation();
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
    },

    submit() {
      this.$refs.contractForm.validate();

      if (this.isFormValid) {
        this.$emit('submit', this.contract);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-modal {
  &__row {
    margin-right: -8px;
    margin-left: -8px;
  }

  &__col {
    padding: 0 8px 8px;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
  }

  &__submit {
    font-weight: 400;
    color: white;
    width: 256px;
    margin-top: 8px;
  }

  &__label-col {
    padding-top: 0;
    padding-bottom: 0;
    letter-spacing: 0px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: $main--headers;
    margin-top: 2px;
    margin-bottom: 6px;
  }

  &__textarea {
    border: 1px solid #E2E6EA;
    border-radius: 4px;
    height: 108px;
  }

  &__actions {
    margin-top: 8px;
  }
}
.form-field--short {
  max-width: 120px;
}
</style>
